import React from 'react';
import { Link } from 'react-router-dom';
import role from '../../util/role'
import {
    PRODUCT_LIST_PAGE_LOADED
} from '../../constants/actionTypes'
const ProductListLink = props => {
    if (!props.currentUser
        || !role.can(props.currentUser.role, PRODUCT_LIST_PAGE_LOADED)
        || !props.userKey) {
        return (
            <span>Product List</span>
        )
    }
    return (
        <Link to={`/products/user/${props.userKey}`}>Product List</Link>
    )
}

export default ProductListLink;



// WEBPACK FOOTER //
// ./src/components/widgets/ProductListLink.js